import * as Immutable from 'immutable';

export interface IViewProductGpsrContactStore {
	id: number
	name: string
	address: string | null
	email: string | null
	phone_number: string | null
}

const defaultViewProductGpsrContactStore = Immutable.Record<IViewProductGpsrContactStore>({
	id: 0,
	name: '',
	address: null,
	email: null,
	phone_number: null,
});

export default class ViewProductGpsrContactStore extends defaultViewProductGpsrContactStore implements IViewProductGpsrContactStore {}
